import $ from 'jquery'
import 'bootstrap/js/modal'
import { getLoginModalInstance } from 'application/login_modal'
import FormatUtils from 'application/format_utils'
import Menu from 'application/shared/menu'
import 'application/shared/header_help'
import hookAmplitudeEvents from './shared/amplitude_events_handler'

#------------------
# Browser warning
#------------------
$('body').addClass(QB.browserName)

if !QB.isTestEnv && QB.isNotSupported
  $('.js-old-browser-alert').show()

_require ['metrics'], ->
  $('.js-install-chrome-link').on 'click', ->
    trackable.eventTracker.track(Metrics.Events.ClickedOldBrowserUpdateLink, { browser: 'chrome' })

  $('.js-install-firefox-link').on 'click', ->
    trackable.eventTracker.track(Metrics.Events.ClickedOldBrowserUpdateLink, { browser: 'firefox' })

#-----------------------------------
# Geolocation
#-----------------------------------
_require [
  'geolocation_v4'
], ->
  new QB.GeolocationV4().initLocationAutocomp()

if QB.isProdEnv
  $('body').delegate '#logout', 'click', (e) ->
    $this = $(this)
    unless $this.data('processed')
      e.preventDefault
      e.stopPropagation
      $this.data('processed', true)

      dataLayer.push({
        event: 'logoutClick',
        eventCallback: () ->
          e.target.dispatchEvent e.originalEvent
      })

_require [
  'bootstrap/popover'
], ->

  #--------------------------------------------
  #Cria tooltips a partir de parametros no HTML.
  #---------------------------------------------
  updateTooltipsAndPopovers = ->
    $("[rel~=tooltip-up]").tooltip
      html: true
      placement: 'top'

    $("[rel~=tooltip-left]").tooltip
      placement: 'left'

    $("[rel~=tooltip-right]").tooltip
      placement: 'right'

    $("[rel~=tooltip-down], [rel~=tooltip]").tooltip
      placement: 'bottom'
      container: 'body'

    $('form input[title], form select[title], form textarea[title]').tooltip
      html: true
      trigger: 'focus'
      placement: ->
        if QB.isMobile then 'top' else 'bottom'

    $('.btn-tooltip').tooltip
      placement: 'top'

    $("body").popover
      html: true
      container: 'body'
      selector: '[data-popover]'
      trigger: 'hover'
      content: ->
        $($(this).data('content-selector')).html() || $(this).find('.popover_content').html()
      title: ->
        $($(this).data('content-selector')).prop('title') || $(this).find('.popover_content').prop('title') || $(this).data('original-title')

    $('.btn-popover, .pop').popover()

    if QB.courseIsGraduated is true
      $('.js-level-pos-grad').show()
      $('.js-level-grad').hide()
    else
      $('.js-level-pos-grad').hide()
      $('.js-level-grad').show()

    return

  # --------------
  # TOOLTIPS
  # --------------
  updateTooltipsAndPopovers()

  #------------------
  # Popover
  #------------------
  newPopoverTemplate = $($.fn.popover.Constructor.DEFAULTS.template).removeClass('grey-popover').addClass('new-popover')

  $("#footer .politica-holder").popover
    html: true,
    container: 'body',
    trigger: 'hover',
    content:  $("#bolsa-garantida-popover").html(),
    template: newPopoverTemplate
    placement: 'top'

  $("#footer .reclame-holder").popover
    html: true,
    container: 'body',
    trigger: 'hover',
    content:  $("#selo-reclame-popover").html(),
    template: newPopoverTemplate
    placement: 'top'

  $(".js-call-0800").popover
    html: true,
    trigger: 'hover',
    container: '.js-call-0800',
    content:  $('.js-call-0800-popover').html(),
    template: newPopoverTemplate.clone().removeClass('new-popover').addClass('header-popover header-popover--alert'),
    placement: 'bottom'

  $(".js-call-0800-checkout").popover
    html: true,
    trigger: 'hover',
    container: '.js-call-0800-checkout',
    content: $('.js-call-0800-popover').html(),
    template: newPopoverTemplate.clone().removeClass('new-popover').addClass('header-popover header-popover--alert'),
    placement: 'bottom'

  $('.js-how-it-works-menu').popover
    html: true,
    trigger: 'hover',
    container: '.js-how-it-works-menu',
    content:  $('.js-how-it-works-header').html(),
    template: newPopoverTemplate.clone().removeClass('new-popover').addClass('header-popover header-popover--alert header-popover--left'),
    placement: 'bottom'

  $('.js-user-menu-container').popover
    html: true,
    container: '.js-user-menu-container',
    trigger: 'manual',
    content:  $(".js-user-menu").html(),
    template: newPopoverTemplate.clone().removeClass('new-popover').addClass('header-popover header-popover--mobile-nav'),
    placement: 'bottom'

_require [
  'bootstrap/popover',
], ->
  ##-----------------------##
  # Behavior of Login Modal #
  ##-----------------------##
  loginModal = getLoginModalInstance()
  loginModal.checkForFragment()

  #----------------------
  # Checkout
  #----------------------
  $("#cart-btn").click ->
    $(".cart-wrap").slideToggle('fast')
    $(this).toggleClass('active')
    return

  $("#voucher-btn").click (e)->
    e.preventDefault()
    $("#voucher_info").slideToggle('fast')
    $(this).toggleClass('active')
    return

#----------------------------------------
# Countdown floating bar
#----------------------------------------

floatingBarElement = document.querySelector('#js-countdown-floating-bar-undergraduation')

# Start hooking events at amplitude
$(window).on 'load':->
  hookAmplitudeEvents()

if floatingBarElement
  $(window).on 'scroll':->
    currentScrollPos = window.pageYOffset

    if currentScrollPos > 200
      floatingBarElement.classList.add('countdown-floating-bar__bar--active')
    else
      floatingBarElement.classList.remove('countdown-floating-bar__bar--active')

  nowDate = new Date().getTime()
  campaignEndDate = QB.campaignEndDate

  setInterval () ->
    endDate = new Date(campaignEndDate + 'T23:59:59-03:00')
    nowDate = nowDate + 1000

    diff = (endDate.getTime() - nowDate) / 1000

    days = Math.floor(diff / 86400)
    diff = diff - days * 86400
    hours = Math.floor(diff / 3600) % 24
    diff = diff - hours * 3600
    minutes = Math.floor(diff / 60) % 60
    diff = diff - minutes * 60
    seconds = Math.floor(diff % 60)

    document.querySelector('#js-campaign-countdown-days-undergraduation').textContent = FormatUtils.padNumber(days)
    document.querySelector('#js-campaign-countdown-hours-undergraduation').textContent = FormatUtils.padNumber(hours)
    document.querySelector('#js-campaign-countdown-minutes-undergraduation').textContent = FormatUtils.padNumber(minutes)
    document.querySelector('#js-campaign-countdown-seconds-undergraduation').textContent = FormatUtils.padNumber(seconds)
  , 1000


#----------------------------------------
# Countdown floating bar (postgraduate)
#----------------------------------------

postgraduateFloatingBarElement = document.querySelector('#js-countdown-floating-bar-postgraduation')

if postgraduateFloatingBarElement
  $(window).on 'scroll':->
    currentScrollPositionPosgrad = window.pageYOffset

    if currentScrollPositionPosgrad > 200
      postgraduateFloatingBarElement.classList.add('countdown-floating-bar__bar--active')
    else
      postgraduateFloatingBarElement.classList.remove('countdown-floating-bar__bar--active')

  nowDatePosgrad = new Date().getTime()
  posgradCampaignEndDate = QB.posgradCampaignEndDate

  setInterval () ->
    endDatePostgraduate = new Date(posgradCampaignEndDate + 'T23:59:59-03:00')
    nowDatePosgrad = nowDatePosgrad + 1000

    diffPosgrad = (endDatePostgraduate.getTime() - nowDatePosgrad) / 1000

    daysPosgrad = Math.floor(diffPosgrad / 86400)
    diffPosgrad = diffPosgrad - daysPosgrad * 86400
    hoursPosgrad = Math.floor(diffPosgrad / 3600) % 24
    diffPosgrad = diffPosgrad - hoursPosgrad * 3600
    minutesPosgrad = Math.floor(diffPosgrad / 60) % 60
    diffPosgrad = diffPosgrad - minutesPosgrad * 60
    secondsPosgrad = Math.floor(diffPosgrad % 60)

    document.querySelector('#js-campaign-countdown-days-postgraduation').textContent = FormatUtils.padNumber(daysPosgrad)
    document.querySelector('#js-campaign-countdown-hours-postgraduation').textContent = FormatUtils.padNumber(hoursPosgrad)
    document.querySelector('#js-campaign-countdown-minutes-postgraduation').textContent = FormatUtils.padNumber(minutesPosgrad)
    document.querySelector('#js-campaign-countdown-seconds-postgraduation').textContent = FormatUtils.padNumber(secondsPosgrad)
  , 1000

#----------------------------------------
# Load YouTube video into a simple modal
#----------------------------------------
window.loadYouTubeModal = (videoId, scope) ->
  _require ['yt_iframe_api'], ->
    track = null

    loadModal = ->
      overlay = $('<div class="overlay youtube-overlay" />')
      $('body').append(overlay)
      videoPlaceholder = $('<div class="video-placeholder"><div class="embed-responsive embed-responsive-16by9"><div id="youtube-player" class="embed-responsive-item" /></div><span class="close"></span></div>')
      $('body').append(videoPlaceholder)

      if QB.isMobile
        height = '100%'
        width = '100%'
      else
        height = '450'
        width = '800'

      close = ->
        track()
        $(window).off('unload.player')
        videoPlaceholder.empty().remove()
        overlay.remove()

      player = new YT.Player 'youtube-player',
        height: height
        width: width
        videoId: videoId
        playerVars:
          autoplay: 1
          rel: 0
          controls: 0
        events:
          onStateChange: (ev) ->
            if ev.data is YT.PlayerState.ENDED
              close()
            return
          onReady: (ev) ->
            $(window).on('unload.player', track)
            # https://developers.google.com/youtube/iframe_api_reference#Playback_quality
            ev.target.setPlaybackQuality('large') if !QB.isMobile
            return

      track = ->
        properties =
          scope: scope
          videoId: videoId
          viewing_time: if player && player.getCurrentTime then (parseInt(player.getCurrentTime()) + 's') else 'unknown'
          path: document.location.pathname

        _require ['metrics'], ->
          trackable.eventTracker.track(Metrics.Events.ViewedVideo, properties)

      overlay.click(close)
      videoPlaceholder.find('.close').click(close)

    if YT.loaded
      loadModal()

    window.onYouTubeIframeAPIReady = ->
      loadModal()

$(document.body).on 'click', '.js-load-youtube-modal', ->
  { videoId, scope } = this.dataset
  loadYouTubeModal(videoId, scope)

# Footer links clicks tracking
$('.js-open-courses-link').on 'click', ->
  _require ['metrics'], ->
    trackable.eventTracker.track(Metrics.Events.ClickedOpenCoursesLink, { path: document.location.pathname })

if QB.isProdEnv
  _require ['contact_us'], ->
    fresh = new QB.Freshdesk()

    $('.js-fresh-desk-link').click () ->
      fresh.show()

# campaign header click tracking
$('.js-on-campaign-highlight-button').on('click', (e) ->
  _require(['metrics'], () ->
    trackable.eventTracker.track(Metrics.Events.ClickedCampaignHighlightButton, {
      path: document.location.pathname,
      type: e.currentTarget.dataset.type
    })
  )
)

# Footer submenus mobile
$footerSubmenu = $('.js-footer-submenu')
$footerSubmenu.click ->
  $this = $(this)
  $footerSubmenu.not($this).removeClass 'footer-submenu-wrapper--active'
  $this.toggleClass 'footer-submenu-wrapper--active'
  return

# Follow Up button
$followUpPopover = $(".js-follow-up-popover")

$(document).on('click', (event)->
  clickOutsideModal = !$(event.target).closest($followUpPopover).length

  if (clickOutsideModal)
    $followUpPopover.removeClass('header-follow-up__popover-wrapper--show')
)

setTimeout () ->
  $followUpPopover.addClass('header-follow-up__popover-wrapper--show')
, 1000
